<template>
  <div v-if="stockTakeOrder && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="stockTakeOrder" />
  </div>
</template>
<script>
import StockTakes from "@/api/stock_takes";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import { mapState } from "vuex";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    stockTakeOrder: {},
  }),
  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo"]),
  },
  mounted() {
    PrintTemplates.fetchOne("shopInventoryStockOrderTake").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.print_template.template;
          this.formater = formater;

          //获取单据详情
          StockTakes.stockTakeOrderPrint(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockTakeOrder = response.data.stock_take;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  }

};
</script>
